import { render, staticRenderFns } from "./CreateModule.vue?vue&type=template&id=a3cbc726"
import script from "./CreateModule.vue?vue&type=script&lang=js"
export * from "./CreateModule.vue?vue&type=script&lang=js"
import style0 from "./CreateModule.vue?vue&type=style&index=0&id=a3cbc726&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports